// @flow
import * as React from 'react';
import { Link } from 'react-router';
import { Row, Col, Button } from 'react-bootstrap';
import fuzzyFilterFactory from 'react-fuzzy-filter';
import { CSSTransitionGroup } from 'react-transition-group';
import PaginatedList from '../../components/PaginatedList';
import ListFilterBox from '../../components/ListFilterBox';
import type { Organisation } from '../../types';

type Props = {
  currentOrganisation: Organisation,
  params: {
    customerId: string | number,
    context: string,
    locationId: string | number
  },
  route: any,
  router: any,
  currentCustomer: Organisation,
  removeUserFromOrganisation: Function,
  getOrganisationUsers: Function
};

type State = {
  newUserId?: ?any,
  showNewUser?: boolean,
  filterValue: string,
  isSaving?: boolean,
  errorMsg?: any,
  successMsg?: any
};

const ControlHeader = props => (
  <Row className="row-header tools">
    <Col sm={4} className="table-header">
      <ListFilterBox
        onChange={props.filterBoxChange}
        fuzzyFilterFactory={props.fuzzyFilterFactory}
      />
    </Col>
    <Col sm={5} className="table-header" />
    <Col sm={3} className="table-header">
      <Button
        bsStyle="primary"
        type="submit"
        className="relative-padding"
        onClick={props.addButtonClick}
      >
        Add User
      </Button>
    </Col>
  </Row>
);

const LineItem = props => {
  const { item, removeUser, params } = props;
  return (
    <Row key={item.id}>
      <Col sm={5} className="table-entry">
        <Link to={`/${params.context}/${params.customerId}/users/${item.id}`}>
          {item.name}
        </Link>
      </Col>
      <Col sm={2} className="table-entry">
        {item.isArchived ? 'Archived' : 'Active'}
      </Col>
      {/* Super User are not listed for this sub-account */}
      <Col sm={3} className="table-entry text-center">
        {!item.userOrganisationId ? 'Yes' : 'No'}
      </Col>
      <Col sm={2} className="table-entry">
        {item.userOrganisationId && (
          <Button
            bsStyle="link"
            onClick={e => removeUser(item)}
            aria-label={`Remove ${item.name}`}
          >
            Remove
          </Button>
        )}
      </Col>
    </Row>
  );
};

class LocationUsers extends React.Component<Props, State> {
  timeoutId: any;
  fuzzyFilterFactory: any;
  screenReaderContent: any;
  static displayName = 'LocationUsers';

  constructor(props: Props) {
    super(props);

    this.state = {
      filterValue: ''
    };
    this.timeoutId = undefined;
    this.fuzzyFilterFactory = fuzzyFilterFactory();
  }

  componentDidMount() {
    this.getUsers();
    this.screenReaderContent.focus();
  }

  componentWillUnmount() {
    // clear timeout to prevent setState on unmounted component
    clearTimeout(this.timeoutId);
  }

  getUsers = () => {
    const organisationId = parseInt(this.props.params.locationId, 10);
    this.props.getOrganisationUsers(organisationId, true);
    this.props.getOrganisationUsers(organisationId, false);
  };

  // TODO: Need to get userOrganisationId from API before this can work.
  removeUser = (user: any) => {
    this.setState({
      isSaving: true,
      errorMsg: undefined,
      successMsg: undefined
    });

    const organisationId = parseInt(this.props.params.locationId, 10);
    this.props.removeUserFromOrganisation(user, organisationId).then(
      response => {
        this.getUsers();
        this.success(response);
      },
      error => this.failure(error)
    );
  };

  success = (response: any) => {
    this.setState({
      isSaving: false,
      errorMsg: undefined,
      successMsg: 'Success!'
    });
    this.timeoutId = setTimeout(
      () => this.setState({ successMsg: undefined }),
      3000
    );
  };

  failure = (error: any) => {
    this.setState({ isSaving: false, errorMsg: error.data.message });
  };

  addButtonClick = () => {
    const { customerId, locationId, context } = this.props.params;
    localStorage.setItem(
      'backUrl',
      `${context}/${customerId}/sub-accounts/${locationId}/userList`
    );
    this.props.router.push(`/sub-account/${locationId}/users/invite`);
  };

  updateFilterValue = (filterValue: any) => {
    this.setState({ filterValue: filterValue || '' });
  };

  render() {
    const { currentCustomer } = this.props;
    const { allocated } = currentCustomer.users;

    const LineItemWrapper = props => (
      <LineItem
        {...props}
        currentCustomer={currentCustomer}
        removeUser={this.removeUser}
        params={this.props.params}
      />
    );
    return (
      <div>
        <Row />
        <h3
          className="screen-reader-only"
          tabIndex="-1"
          ref={i => (this.screenReaderContent = i)}
        >
          Showing users for customer {this.props.currentCustomer.name}
        </h3>

        <ControlHeader
          filterBoxChange={this.updateFilterValue}
          fuzzyFilterFactory={this.fuzzyFilterFactory}
          addButtonClick={this.addButtonClick}
        />
        <Row>
          <Col sm={5} className="table-header">
            Name
          </Col>
          <Col sm={2} className="table-header">
            Status
          </Col>
          <Col sm={3} className="table-header text-center">
            Can access all stores?
          </Col>
          <Col sm={2} className="table-header text-center">
            Actions
          </Col>
        </Row>
        <hr />

        <PaginatedList
          filterValue={this.state.filterValue}
          component={LineItemWrapper}
          items={allocated}
          fuzzyFilterFactory={this.fuzzyFilterFactory}
          pluralName="users"
        />
        <Row>
          <Col sm={12}>
            <CSSTransitionGroup
              transitionName="fade"
              transitionEnterTimeout={300}
              transitionLeaveTimeout={300}
            >
              {this.state.successMsg && (
                <p className="text-success">{this.state.successMsg}</p>
              )}
            </CSSTransitionGroup>
          </Col>
        </Row>
        {this.state.errorMsg && (
          <div className="alert alert-danger">{this.state.errorMsg}</div>
        )}
      </div>
    );
  }
}

export default LocationUsers;



// WEBPACK FOOTER //
// ./src/containers/location/LocationUsers.js